var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#2563EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.0859 17L19.9141 17L18.513 15.393C17.1396 13.8176 18.7418 11.463 20.7471 12.1098L21.6748 12.4091C21.8861 12.4773 22.1139 12.4773 22.3252 12.4091L23.2529 12.1098C25.2582 11.463 26.8604 13.8176 25.487 15.393L24.0859 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.6845 20.2103C16.4673 17.7055 18.7871 16 21.4114 16H22.5891C25.2134 16 27.5332 17.7055 28.316 20.2104L29.566 24.2104C30.7734 28.0739 27.887 32 23.8391 32H20.1614C16.1136 32 13.2272 28.0739 14.4345 24.2104L15.6845 20.2103Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30C22 28.8954 22.8954 28 24 28H30C31.1046 28 32 28.8954 32 30C32 31.1046 31.1046 32 30 32H24C22.8954 32 22 31.1046 22 30Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26C22 24.8954 22.8954 24 24 24H29.3333H30C31.1046 24 32 24.8954 32 26C32 27.1046 31.1046 28 30 28H24C22.8954 28 22 27.1046 22 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTools);
export default __webpack_public_path__ + "static/media/all-tools.87297b6cc83d5592c3123dedd4097229.svg";
export { ForwardRef as ReactComponent };